<template>
  <basic-dialog :show="show" maxWidth="500" @close="$emit('close')">
    <template v-slot:title>Create Template</template>
    <v-row>
      <v-col class="pb-0">
        <v-text-field
          label="Template Name"
          v-model="name"
          :outlined="$store.getters.localSettings('outlinedInputs')"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-textarea
          label="Description"
          rows="6"
          :outlined="$store.getters.localSettings('outlinedInputs')"
          v-model="description"
        ></v-textarea>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onCreate" :disabled="!isValid"
        >Create</v-btn
      >
    </template>
    <div v-if="debug">
      <code>{{ templateInput }}</code>
      <code>{{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../../shared/BasicDialog.vue";
const moment = require("moment");
const randomize = require("randomatic");
const CREATE_TEMPLATE = gql`
  mutation createTemplate($input: TemplateInput!) {
    createTemplate(templateInput: $input) {
      id
      name
    }
  }
`;
export default {
  name: "template-from-iti",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      name: "",
      description: "",
    };
  },

  computed: {
    isValid() {
      return this.name != "";
    },
    templateInput() {
      if (this.value) {
        const itStart = moment(this.value.startDate);
        const itEnd = moment(this.value.endDate);
        const duration = itEnd.diff(itStart.startOf("day"), "days");
        return {
          name: this.name,
          description: this.description,
          duration,
          department: this.value ? this.value.department : "",
          destinationId: this.value ? this.value.destinationId : "",
          items: this.value.items.map(this.mapToTemplateItem(itStart, itEnd)),
        };
      } else {
        return {};
      }
    },
  },

  methods: {
    mapToTemplateItem(itiStart, itiEnd) {
      return (item) => {
        const itemStart = moment(item.startDate);
        const itemEnd = moment(item.endDate);
        const day =
          itemStart.startOf("day").diff(itiStart.startOf("day"), "days") + 1;

        let duration = itemEnd.diff(itemStart, "days");
        if (duration == 0) {
          duration = 1;
        }
        const extras = item.extras.map(
          this.mapToTemplateItemExtra(itiStart, itiEnd)
        );

        return {
          uid: randomize("Aa0", 32),
          order: item.orderNo,
          serviceId: item.serviceId,
          day,
          duration,
          extras,
        };
      };
    },
    mapToTemplateItemExtra(itiStart, itiEnd) {
      return (extra) => {
        const extraStart = moment(extra.startDate);
        const extraEnd = moment(extra.endDate);
        const day =
          extraStart.startOf("day").diff(itiStart.startOf("day"), "days") + 1;

        let duration = extraEnd.diff(extraStart, "days");
        if (duration == 0) {
          duration = 1;
        }
        return {
          extraId: extra.id,
          day,
          duration,
        };
      };
    },
    onCreate() {
      this.$apollo
        .mutate({
          mutation: CREATE_TEMPLATE,
          variables: { input: { ...this.templateInput } },
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Template Created",
          });
          this.$emit("created", { ...res.data.createTemplate });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/TemplateFromItineraryDialog.vue